import { dew as _abstractRefinersDew } from "../abstractRefiners";
import { dew as _mergingCalculationDew } from "../../calculation/mergingCalculation";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const abstractRefiners_1 = _abstractRefinersDew();
  const mergingCalculation_1 = _mergingCalculationDew();
  class AbstractMergeDateTimeRefiner extends abstractRefiners_1.MergingRefiner {
    shouldMergeResults(textBetween, currentResult, nextResult) {
      return (currentResult.start.isOnlyDate() && nextResult.start.isOnlyTime() || nextResult.start.isOnlyDate() && currentResult.start.isOnlyTime()) && textBetween.match(this.patternBetween()) != null;
    }
    mergeResults(textBetween, currentResult, nextResult) {
      const result = currentResult.start.isOnlyDate() ? mergingCalculation_1.mergeDateTimeResult(currentResult, nextResult) : mergingCalculation_1.mergeDateTimeResult(nextResult, currentResult);
      result.index = currentResult.index;
      result.text = currentResult.text + textBetween + nextResult.text;
      return result;
    }
  }
  exports.default = AbstractMergeDateTimeRefiner;
  //# sourceMappingURL=AbstractMergeDateTimeRefiner.js.map
  return exports;
}